import { MuiTelInput } from "mui-tel-input";

import { styled } from "@mui/material/styles";

const PhoneInput = styled(MuiTelInput)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,

  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: theme.palette.text.primary,
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: '4px',
  },

  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
    borderColor: theme.palette.primary.light,
    borderWidth: 1,
  },

  "& .Mui-error": {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.primary.main,

    "&.MuiFormHelperText-root": {
      background: "none",
    },
  },

  "& .MuiInputBase-multiline": {
    display: "flex",
    flexDirection: "column",

    "& .MuiInputBase-inputMultiline": {
      marginBottom: theme.spacing(1),
    },
  },
}));

export default PhoneInput;
